module.exports = __webpack_public_path__ + "static/media/share-icon.1737416d.svg";